const frequencyUnitList = ['HOUR', 'DAY', 'MONTH', 'YEAR', 'INF'];

export default frequencyUnitList;
